/* Função responsável por converter data para o formato DD/MM/YYYY*/
export const formatarDataPtBr = (dataISO: string): string => {
	const data = new Date(dataISO);
	const dia = String(data.getDate()).padStart(2, '0');
	const mes = String(data.getMonth() + 1).padStart(2, '0');
	const ano = data.getFullYear();

	return `${dia}/${mes}/${ano}`;
};
